export default "__VITE_ASSET__CTqG_L2z__"